// @spec GHG-STR-026
'use client';

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/ghg/recalculations/$recalculationId')({
  beforeLoad: () => {
    // TanStack Router requires throwing the redirect result
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/ghg/calculations/scope1', replace: true });
  },
});
